module.exports = __webpack_public_path__ + "static/media/tour-1.0198d515.jpg";